import { useState } from "preact/hooks"
import type { User } from "../types"
import { logout } from "./lib/api"

interface NavbarProps {
	path: string
	user: User
	onLoggedOut: () => void
}

export function Navbar({ path, user, onLoggedOut }: NavbarProps) {
	const [loggingOut, setLoggingOut] = useState(false)
	const homeActive = path === "/"
	const friendsActive = path === "/friends"
	const meActive = path === "/me"

	async function handleLogout() {
		setLoggingOut(true)
		try {
			await logout()
		} finally {
			// Log the user out client-side even if the request failed — an
			// already-dead session shouldn't strand the user on the page.
			onLoggedOut()
		}
	}

	return (
		// .navbar wraps rather than forcing one row: on a phone that is what
		// used to push Logout clean off the right edge with no way to reach it.
		<nav class="navbar">
			<a class="plain inline-flex center gap-2 mr-2" href="/">
				<img src="/static/brand/logo.svg" alt="" width="28" height="28" />
				{/* The logo alone carries the brand on a phone; the wordmark is
				    what made the row overflow in the first place. */}
				<span class="brand-name hide-narrow">Quizfish</span>
			</a>
			<span class="grow" />
			<a
				class="nav-link"
				href="/"
				aria-current={homeActive ? "page" : undefined}
			>
				Home
			</a>
			<a
				class="nav-link"
				href="/friends"
				aria-current={friendsActive ? "page" : undefined}
			>
				Friends
			</a>
			<a
				class="nav-link"
				href="/me"
				aria-current={meActive ? "page" : undefined}
			>
				{user.username}
			</a>
			<button
				type="button"
				class="sm ml-1"
				onClick={handleLogout}
				disabled={loggingOut}
			>
				Log out
			</button>
		</nav>
	)
}
